import contentTypeToName_en from '@/assets/configurations/content/typeToName_en'

/**
   * Gives connect label for the given channel
   * @returns {String}
   */
const connectLabel = function (type) {
  return `Channel.${type}.connectLabel`
}

/**
 * Tells params for a channel type or a campaign
 * @param {String} type Channel/Campaign type
 * @returns {Object} Object of params
 */
const extract = function (type) {
  let rtr = {}

  switch (type) {
    case 'facebookProfile':
      rtr = {
        icon: 'facebook',
        pack: 'coloredBg',
        lightIcon: 'facebook',
        postType: {
          importedProduct: 'facebookPost',
          product: 'facebookPost',
          post: 'facebookPost',
          news: 'facebookPost'
        }
      }
      break

    case 'facebookPage':
      rtr = {
        icon: 'facebook',
        pack: 'coloredBg',
        lightIcon: 'facebook',
        postType: {
          importedProduct: 'facebookPost',
          product: 'facebookPost',
          post: 'facebookPost',
          news: 'facebookPost'
        }
      }
      break

    case 'wordpressUser':
      rtr = {
        icon: 'wordpressCircle',
        pack: 'clear',
        lightIcon: 'wordpressCircle',
        postType: {
          importedProduct: 'woocommerceProduct',
          product: 'woocommerceProduct',
          post: 'wordpressPost',
          news: 'wordpressPost'
        }
      }
      break

    case 'wordpressWebsite':
      rtr = {
        icon: 'wordpressCircle',
        pack: 'clear',
        lightIcon: 'wordpressCircle',
        postType: {
          importedProduct: '// NOTE: unused',
          product: '// NOTE: unused',
          post: '// NOTE: unused',
          news: '// NOTE: unused'
        }
      }
      break

    case 'googlePlusProfile':
      rtr = {
        icon: 'googlePlus',
        pack: 'coloredBg',
        lightIcon: 'googlePlus',
        postType: {
          importedProduct: 'googleAdSenseAd',
          product: 'googleAdSenseAd',
          post: 'googleAdSenseAd',
          news: 'googleAdSenseAd'
        }
      }
      break

    case 'informacijaShop':
      rtr = {
        icon: 'informacijaNet',
        pack: 'coloredBg',
        lightIcon: 'informacijaNet',
        postType: {
          importedProduct: 'informacijaProduct',
          product: 'informacijaProduct',
          post: 'informacijaPost',
          news: 'informacijaPost'
        }
      }
      break

    case 'sqwizPage':
      rtr = {
        icon: 'sqwizr',
        pack: 'clear',
        lightIcon: 'sqwizr',
        postType: {
          importedProduct: 'sqwizProduct',
          product: 'sqwizProduct',
          post: 'sqwizArticle',
          news: 'sqwizArticle'
        }
      }
      break

    case 'shopamineShop':
      rtr = {
        icon: 'shopamine',
        pack: 'coloredBg',
        lightIcon: 'shopamine',
        postType: {
          importedProduct: 'shopamineProduct',
          product: 'shopamineProduct',
          post: 'shopaminePost',
          news: 'shopaminePost'
        }
      }
      break

    case 'shopifyShop':
      rtr = {
        icon: 'shopify',
        pack: 'clear',
        lightIcon: 'shopify',
        postType: {
          importedProduct: 'shopifyProduct',
          product: 'shopifyProduct',
          post: 'shopifyProduct',
          news: 'shopifyProduct'
        }
      }
      break

    case 'wooCommerceShop':
      rtr = {
        icon: 'woocommerce',
        pack: 'clear',
        lightIcon: 'woocommerce',
        postType: {
          importedProduct: null,
          product: null,
          post: null,
          news: null
        }
      }
      break

    case 'elasticEmailAccount':
      rtr = {
        icon: 'elasticMail',
        pack: 'clear',
        lightIcon: undefined,
        postType: {
          importedProduct: 'elasticEmailSendout',
          product: 'elasticEmailSendout',
          post: 'elasticEmailSendout',
          news: 'elasticEmailSendout'
        }
      }
      break

    case 'instagramProfile':
      rtr = {
        icon: 'instagram',
        pack: 'coloredBg',
        lightIcon: undefined,
        postType: {
          importedProduct: 'instagramPhoto',
          product: 'instagramPhoto',
          post: 'instagramPhoto',
          news: 'instagramPhoto'
        }
      }
      break

    case 'twitterProfile':
      rtr = {
        icon: 'twitter',
        pack: 'coloredBg',
        lightIcon: 'twitter',
        postType: {
          importedProduct: 'twitterTweet',
          product: 'twitterTweet',
          post: 'twitterTweet',
          news: 'twitterTweet'
        }
      }
      break

    case 'pinterestProfile':
      rtr = {
        icon: 'pinterest',
        pack: 'coloredBg',
        lightIcon: 'pinterest',
        postType: {
          importedProduct: 'pinterestPin',
          product: 'pinterestPin',
          post: 'pinterestPin',
          news: 'pinterestPin'
        }
      }
      break

    case 'pinterestBoard':
      rtr = {
        icon: 'pinterest',
        pack: 'coloredBg',
        lightIcon: 'pinterest',
        postType: {
          importedProduct: 'pinterestPin',
          product: 'pinterestPin',
          post: 'pinterestPin',
          news: 'pinterestPin'
        }
      }
      break

      case 'productPromotion':
        rtr = {
          icon: 'productPromotion',
          pack: 'campaign',
          campaignType: 'promoteProduct'
        }
        break

      case 'dailyDeal':
        rtr = {
          icon: 'dailyDeal',
          pack: 'campaign',
          campaignType: 'dailyDeal'
        }
        break

      case 'sale':
        rtr = {
          icon: 'sale',
          pack: 'campaign',
          campaignType: 'saleProduct'
        }
      break

    default:
      return {}
  }

  rtr.label = `Channel.${type}.label`
  return rtr
}

/**
 * Determines the channel type that belongs to the given post type
 * @param {String} postType Post type we are interested in
 * @returns {String} Channel type for that post type
 */
const postTypeToChannelType = (postType) => {
  switch (postType) {
    case 'facebookPost':
      return 'facebookPage'

    case 'facebookAd':
      return 'facebookPage'

    case 'twitterTweet':
      return 'twitterProfile'

    case 'sqwizArticle':
      return 'sqwizPage'

    case 'sqwizProduct':
      return 'sqwizPage'

    case 'instagramPost':
      return 'instagramProfile'

    case 'pinterestPost':
      return 'pinterestBoard'

    case 'pinterestPin':
      return 'pinterestBoard'

    case 'shopifyProduct':
      return 'shopifyShop'

    case 'shopamineProduct':
      return 'shopamineShop'

    case 'shopaminePost':
      return 'shopamineShop'

    case 'googleAdSenseAd':
      return 'googlePlusProfile'

    case 'informacijaPost':
      return 'informacijaShop'

    case 'informacijaProduct':
      return 'informacijaShop'

    case 'wordpressPost':
      return 'wordpressUser'

    case 'woocommerceProduct':
      return 'wordpressUser'
  }

  return undefined
}

export { connectLabel, extract, postTypeToChannelType }

export default {
  extract,
  postTypeToChannelType,

  /**
   * Returns the name of a font awesome version of the icon
   * @param {String} type Channel type
   */
  faIcon (type) {
    switch (type) {
      case 'facebookPage':
        return '<i class="fab fa-facebook-square"></i>'

      case 'twitterProfile':
        return '<i class="fab fa-twitter-square"></i>'

      case 'sqwizPage':
        return '<i class="fas fa-globe"></i>'

      case 'instagramProfile':
        return '<i class="fab fa-instagram"></i>'

      case 'pinterestBoard':
        return '<i class="fab fa-pinterest-square"></i>'

      case 'shopifyShop':
        return '<i class="fas fa-shopping-cart"></i>'

      case 'shopamineShop':
        return '<i class="fas fa-shopping-basket"></i>'

      case 'googlePlusProfile':
        return '<i class="fab fa-google-plus-square"></i>'

      case 'productPromotion':
        return '<i class="fab fa-product-hunt"></i>'

      case 'dailyDeal':
        return '<i class="fab fa-product-hunt"></i>'

      case 'sale':
        return '<i class="fab fa-product-hunt"></i>'

      case 'informacijaShop':
        return '<i class="fas fa-info-circle"></i>'

    }
    return null
  },

  /**
   * Gives params for a given content type, such as mutation and label
   * @param {String} type Content type
   * @returns {Object}
   */
  content (type) {
    let rtr = {}
    let typeNameObject = getContentTypeNameJson(null) || {}
    rtr.label = typeNameObject[type].label

    let mutationType = ''
    switch (type) {
      case 'ContentEmail':
        mutationType = 'email'
        break

      case 'ContentPage':
        mutationType = 'page'
        break

      case 'ContentSnippet':
        mutationType = 'snippet'
        break
    }

    rtr.type = type
    rtr.mutationType = mutationType

    return rtr
  },

  connectLabel,

  /**
   * Removes informacija prefix from a label if it's owner is a correct type
   * @param {String} type Label's owner's type
   * @param {String} label Label to be processed
   */
  removeInformacijaPrefix (type, label) {
    if (type === 'informacijaShop') {
      label = label.split('informacija.net,')
      label = label.filter(l => l).map(l => l.trim()).join(' ').trim()
    }

    return label
  }
}

/**
 * Returnes a JOSN of content type -> channel label for the given language
 * @param {*} lang Language the user would like to use
 */
function getContentTypeNameJson (lang) {
  return contentTypeToName_en
}



// WEBPACK FOOTER //
// ./src/assets/modules/channels/paramExtractor.js